<template>
  <div>
    <div id="g_id_onload"
      :data-client_id="googleClientId"
      data-callback="onGoogleLogin"
      data-auto_prompt="true"
    ></div>
    <div ref="signinBtn" class="g_id_signin"
      data-type="standard"
      data-size="large"
      data-theme="outline"
      data-text="sign_in_with"
      data-shape="rectangular"
      data-logo_alignment="left"
    ></div>
  </div>
</template>

<script>
export default {
  name: 'GoogleLogin',
  data () {
    return {
      googleClientId: '398919518442-tn0kcudkggef1p54q3jf5f6lnc9jjbfi.apps.googleusercontent.com'
    }
  },
  mounted () {
    window.onGoogleLogin = this.onGoogleLogin

    const existing = document.getElementById('google-client-script')
    if (!existing) {
      const script = document.createElement('script')
      script.src = 'https://accounts.google.com/gsi/client'
      script.async = true
      script.defer = true
      script.id = 'google-client-script'
      script.onload = this.initializeGsi
      document.head.appendChild(script)
    } else {
      this.initializeGsi()
    }
  },
  methods: {
    onGoogleLogin (response) {
      this.$store.dispatch('loginByGoogle', response.credential)
    },
    initializeGsi () {
      if (window.google && window.google.accounts) {
        window.google.accounts.id.initialize({
          client_id: this.googleClientId,
          callback: this.onGoogleLogin
        })

        // 強制渲染按鈕（避免消失）
        this.$refs.signinBtn.innerHTML = ''
        window.google.accounts.id.renderButton(this.$refs.signinBtn, {
          theme: 'outline',
          size: 'large',
          text: 'sign_in_with',
          shape: 'rectangular'
        })
      }
    }
  }
}
</script>

<style scoped>
p {
  margin-top: 12px;
  word-break: break-all;
}
</style>
